import { Field, Formik } from 'formik';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { ReactstrapInput } from '../../components/reactstrap-formik';
import './style.css';
import images from 'assets/images';
import type { IStartChargeProps } from 'types/propTypes';
import { StartChargeSchema } from 'validation/start-charge/start-charge-validation';
import CharityDonationModal from './CharityDonationModal';
import { useStartCharge } from './hooks/StartChargeHook';

const StartCharge = (props: IStartChargeProps) => {
    const initialState = {
        email: '',
        tnc: false,
    };

    const {
        t,
        stationDetails,
        connectorDetails,
        preAuthAmount,
        tncLink,
        charityText,
        isCharityTextTruncate,
        charityLink,
        charityImage,
        donationNote,
        showCharityModal,
        charityAmount,
        email,
        handleSubmit,
        hideCharityModal,
        doPayment,
    } = useStartCharge(props);

    const navigate = useNavigate();

    return (
        <>
            <div className="start-charge">
                <button
                    title={t<string>('stationDetails.button.back')}
                    type="button"
                    className="btn btn-icon pr-0 btn-outline-primary back-button float-right"
                    onClick={() => navigate(-1)}
                >
                    <img
                        className="icon back-button-icon"
                        src={images.backArrowSVG}
                        alt={t<string>('stationDetails.button.back')}
                    />
                </button>
                <Formik
                    initialValues={initialState}
                    onSubmit={(values) => {
                        handleSubmit(values.email);
                    }}
                    validationSchema={StartChargeSchema(t)}
                >
                    {(props) => {
                        const { handleSubmit, handleChange, values, errors } = props;
                        return (
                            <div>
                                <form className="form-primary" onSubmit={handleSubmit} autoComplete="off">
                                    <h4 className="text-left">
                                        Start Charge: {stationDetails && stationDetails.charge_station_name} -{' '}
                                        {connectorDetails && `${connectorDetails.title} ${connectorDetails.voltage}`}
                                    </h4>
                                    <Field
                                        type="text"
                                        name="email"
                                        id="Email"
                                        placeholder={t('startCharge.form.email')}
                                        component={ReactstrapInput}
                                        maxLength={50}
                                    />
                                    <div className="form-group mb-15p mt-1 ta-l">
                                        <div className="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                id="tnc"
                                                name="tnc"
                                                value="tnc"
                                                className="custom-control-input"
                                                checked={values.tnc}
                                                onChange={handleChange}
                                                data-testid="tnc"
                                            />
                                            <label className="custom-control-label pb-0 tx-bold-black" htmlFor="tnc">
                                                <>
                                                    {t('startCharge.label.accept')}{' '}
                                                    <a
                                                        href={tncLink}
                                                        rel="noreferrer"
                                                        className="link-primary"
                                                        target="_blank"
                                                    >
                                                        <>{t('startCharge.label.tnc')}</>
                                                    </a>
                                                </>
                                            </label>
                                        </div>
                                        {errors && errors.tnc && (
                                            <div className="invalid-feedback error d-block p-0">{errors.tnc}</div>
                                        )}
                                    </div>
                                    <Form.Group className="form-group">
                                        <Button type="submit" className="btn btn-primary w-100">
                                            <>{t('startCharge.button.continue')}</>
                                        </Button>
                                    </Form.Group>
                                    <div className="alert-primary p-15p mb-4">
                                        <span>
                                            {t('startCharge.label.preAuthNote').replace(
                                                '{preAuthAmount}',
                                                preAuthAmount.toString(),
                                            )}
                                        </span>
                                    </div>
                                </form>
                            </div>
                        );
                    }}
                </Formik>
            </div>
            {showCharityModal && (
                <CharityDonationModal
                    t={t}
                    charityImage={charityImage}
                    charityLink={charityLink}
                    charityText={charityText}
                    showModal={showCharityModal}
                    isCharityTextTruncate={isCharityTextTruncate}
                    donationNote={donationNote}
                    charityAmount={charityAmount}
                    onHide={() => hideCharityModal()}
                    openDNAPaymentInterface={(isEnableDonation) => doPayment(email, isEnableDonation)}
                />
            )}
        </>
    );
};

export default StartCharge;
